import { Fetcher } from '@this/src/util';
import type { TripResponseArgs } from '@this/domain/trip/trip2';

type TripInfoResponse = {
  trip: TripResponseArgs;
  pusherKey: string;
  pusherChannelPrefix: string;
};

export type TripRealtimeInfo = {
  trip: TripResponseArgs;
  pusherKey: string;
  pusherChannelPrefix: string;
};

export const fetchTripInfo = async (tripId: string): Promise<TripRealtimeInfo> => {
  const response = await Fetcher.get<TripInfoResponse>(`/trips/${tripId}.json`);

  return {
    trip: response.trip,
    pusherKey: response.pusherKey,
    pusherChannelPrefix: response.pusherChannelPrefix
  };
};

export const MESSAGE_SENDER = {
  AI: 'ai',
  USER: 'user'
} as const;

export type MessageSender = typeof MESSAGE_SENDER[keyof typeof MESSAGE_SENDER];
export type LastMessageSender = MessageSender | null;

export type RecentTrip = {
  tripId: string;
  lastMessage: string;
  lastMessageSender: LastMessageSender;
  createdAt: string;
  draft: boolean;
};

type RecentTripResponse = {
  trip_id: number;
  last_message: string;
  last_message_sender: 'ai' | 'user' | null;
  created_at: string;
  draft: boolean;
};

type FetchTripsResponse = {
  trips: RecentTripResponse[];
  has_more: boolean;
};

export type FetchTripsResult = {
  trips: RecentTrip[];
  hasMore: boolean;
};

export const fetchRecentTrips = async (): Promise<RecentTrip[]> => {
  const response = await Fetcher.get<FetchTripsResponse>('/trips/ai_messages/trips.json');

  return response.trips.map(t => ({
    tripId: String(t.trip_id),
    lastMessage: t.last_message,
    lastMessageSender: t.last_message_sender,
    createdAt: t.created_at,
    draft: t.draft
  }));
};

export const fetchTripsWithPagination = async (page: number): Promise<FetchTripsResult> => {
  const response = await Fetcher.get<FetchTripsResponse>(`/trips/ai_messages/trips.json?page=${page}`);

  return {
    trips: response.trips.map(t => ({
      tripId: String(t.trip_id),
      lastMessage: t.last_message,
      lastMessageSender: t.last_message_sender,
      createdAt: t.created_at,
      draft: t.draft
    })),
    hasMore: response.has_more
  };
};
